export default "__VITE_ASSET__BZMv3ZZe__"